<template>
  <div class="check">
    <Header />
    <div uk-height-viewport>
      <div class="uk-flex uk-flex-center">
        <div>
          <br />

          <div
            class="uk-card uk-card-default uk-padding uk-flex uk-flex-center uk-border-rounded"
            v-show="!isLoading"
          >
            <form v-on:submit.prevent="editCheck">
              <fieldset class="uk-fieldset">
                <legend class="uk-legend uk-text-bolder uk-text-left"></legend>
                <div uk-grid>
                  <div class="uk-width-expand@m">
                    <legend class="uk-legend uk-text-bolder uk-text-left">Check</legend>
                  </div>
                  <div class="uk-width-expand@m"></div>
                  <div class="uk-width-auto">
                    <span
                      class="uk-form-danger uk-margin-small-left uk-margin-small-right"
                      style="cursor:pointer;"
                      uk-icon="trash"
                      v-on:click="deleteCheck()"
                      v-show="checkID != ''"
                      uk-tooltip="title: Supprimer; delay: 200"
                    ></span>
                  </div>
                </div>

                <br />

                <div uk-grid>
                  <div class="uk-width-expand@m">
                    <label
                      class="uk-form-label uk-align-left uk-text-bold uk-margin-small-bottom"
                      for="form-stacked-text"
                    >Titre</label>
                    <input
                      class="uk-input uk-border-rounded"
                      v-bind:class="[form.title.hasError ? 'uk-form-danger' : '']"
                      type="text"
                      placeholder="Titre du check"
                      @blur="checkTitle()"
                      v-model="form.title.value"
                      autofocus
                      required
                    />
                    <label
                      class="uk-form-label uk-align-left uk-text-danger"
                    >{{form.title.errorMessage}}</label>
                  </div>
                  <div class="uk-width-expand@m">
                    <label
                      class="uk-form-label uk-align-left uk-text-bold uk-margin-small-bottom"
                      for="form-stacked-text"
                    >Checker</label>

                    <select
                      v-model="selectedChecker"
                      class="uk-select uk-border-rounded inactive"
                      @change="didChangeChecker"
                    >
                      <option :value="{}">Tous</option>
                      <option
                        v-bind:value="checker"
                        v-for="(checker, index) in checkers"
                        :key="index"
                      >{{checker.firstName}} {{checker.lastName}}</option>
                    </select>
                  </div>
                  <div class="uk-width-auto@m">
                    <label
                      class="uk-form-label uk-align-left uk-text-bold uk-margin-small-bottom"
                      for="form-stacked-text"
                    >Status</label>
                    <select
                      class="uk-select uk-border-rounded"
                      v-model="form.status.value"
                      @change="didChangeStatus"
                    >
                      <option
                        v-for="(status, index) in dataStatuses"
                        :value="status.type"
                        :key="index"
                      >{{status.title}}</option>
                    </select>
                  </div>
                </div>

                <div uk-grid>
                  <div class="uk-width-expand@m">
                    <label
                      class="uk-form-label uk-align-left uk-text-bold uk-margin-small-bottom"
                      for="form-stacked-text"
                    >Identité du client</label>
                    <input
                      class="uk-input uk-border-rounded"
                      v-bind:class="[form.customerIdentity.hasError ? 'uk-form-danger' : '']"
                      type="firstName"
                      placeholder="Nom prénom du client"
                      @blur="checkIdentity()"
                      v-model="form.customerIdentity.value"
                      required
                    />
                    <label
                      class="uk-form-label uk-align-left uk-text-danger"
                    >{{form.customerIdentity.errorMessage}}</label>
                  </div>
                </div>

                <br />
                <br />
                <hr />
                <br />

                <legend class="uk-legend uk-text-bolder uk-text-left">À propos du bien</legend>

                <br />

                <div uk-grid>
                  <div class="uk-width-expand@m">
                    <label
                      class="uk-form-label uk-align-left uk-text-bold uk-margin-small-bottom"
                      for="form-stacked-text"
                    >Adresse</label>
                    <input
                      class="uk-input uk-border-rounded"
                      v-bind:class="[form.address.hasError ? 'uk-form-danger' : '']"
                      type="text"
                      v-model="form.address.value"
                      @blur="checkAddress()"
                      placeholder="Rue, Avenue, Chemin..."
                      required
                    />
                    <label
                      class="uk-form-label uk-align-left uk-text-danger"
                    >{{form.address.errorMessage}}</label>
                  </div>
                </div>

                <div uk-grid>
                  <div class="uk-width-auto@m">
                    <label
                      class="uk-form-label uk-align-left uk-text-bold uk-margin-small-bottom"
                      for="form-stacked-text"
                    >Code postal</label>
                    <input
                      class="uk-input uk-border-rounded"
                      v-bind:class="[form.zipCode.hasError ? 'uk-form-danger' : '']"
                      type="text"
                      v-model="form.zipCode.value"
                      placeholder="06250"
                      @blur="isZipCode()"
                      pattern="[0-9]{5}$"
                      required
                    />
                    <label
                      class="uk-form-label uk-align-left uk-text-danger"
                    >{{form.zipCode.errorMessage}}</label>
                  </div>

                  <div class="uk-width-expand@m">
                    <label
                      class="uk-form-label uk-align-left uk-text-bold uk-margin-small-bottom"
                      for="form-stacked-text"
                    >Ville</label>
                    <input
                      class="uk-input uk-border-rounded"
                      v-bind:class="[form.city.hasError ? 'uk-form-danger' : '']"
                      type="text"
                      v-model="form.city.value"
                      @blur="checkCity()"
                      placeholder="Mougins"
                      required
                    />
                    <label
                      class="uk-form-label uk-align-left uk-text-danger"
                    >{{form.city.errorMessage}}</label>
                  </div>

                  <div class="uk-width-expand@m">
                    <label
                      class="uk-form-label uk-align-left uk-text-bold uk-margin-small-bottom"
                      for="form-stacked-text"
                    >Pays</label>
                    <input
                      class="uk-input uk-border-rounded"
                      v-bind:class="[form.country.hasError ? 'uk-form-danger' : '']"
                      type="text"
                      v-model="form.country.value"
                      @blur="checkCountry()"
                      placeholder="France"
                      required
                    />
                    <label
                      class="uk-form-label uk-align-left uk-text-danger"
                    >{{form.country.errorMessage}}</label>
                  </div>
                </div>
                <div uk-grid>
                  <div class="uk-width-expand@m">
                    <label
                      class="uk-form-label uk-align-left uk-text-bold uk-margin-small-bottom"
                      for="form-stacked-text"
                    >Type</label>
                    <select
                      v-model="form.goodType.value"
                      class="uk-select uk-border-rounded inactive"
                    >
                      <option
                        :value="goodType.type"
                        v-for="(goodType, index) in dataGoodTypes"
                        :key="index"
                      >{{goodType.title}}</option>
                    </select>
                    <label
                      class="uk-form-label uk-align-left uk-text-danger"
                    >{{form.goodType.errorMessage}}</label>
                  </div>
                </div>
                <br />
                <br />
                <br />
                <div>
                  <div class="uk-margin uk-grid-small uk-child-width-auto uk-flex uk-flex-center">
                    <button
                      class="uk-button uk-button-primary uk-animation-scale-up uk-border-rounded uk-text-bold"
                    >{{ checkID == '' ? 'Créer le check' : 'Éditer le check' }}</button>
                  </div>
                </div>
              </fieldset>
            </form>
          </div>
          <div
            class="uk-margin uk-grid-small uk-child-width-auto uk-flex uk-flex-center"
            uk-spinner
            v-show="isLoading"
          ></div>
        </div>
      </div>
      <div class="uk-margin uk-grid-small uk-child-width-auto uk-flex uk-flex-center">
        <button
          class="uk-button uk-button-primary uk-animation-scale-up uk-border-rounded uk-text-bold"
          v-show="(check.status == 'done' || check.status == 'invoiced') && !isUploadingReport"
          v-on:click="generateReport()"
        >Mettre à jour le rapport PDF</button>
      </div>
      <div
        class="uk-margin uk-grid-small uk-child-width-small"
        uk-spinner
        v-show="isUploadingReport"
      ></div>
      <div class="uk-margin uk-grid-small uk-child-width-auto uk-flex uk-flex-center">
        <button
          class="uk-button uk-button-primary uk-animation-scale-up uk-border-rounded uk-text-bold"
          v-on:click="consultReport()"
          v-show="check.hasReport && (check.status == 'done' || check.status == 'invoiced')"
        >Consulter le rapport</button>
      </div>
    </div>
  </div>
</template>

<script>
import UIkit from "uikit";
import User from "../models/user";
import Check from "../models/check";
import CheckStatus from "../enums/check-status";
import GoodType from "../enums/good-type";
import NotificationType from "../enums/notification-type";
import FirestoreCollection from "../enums/firestore-collection";
import Header from "../components/Header";
import firebase from "firebase";
import router from "../router";

export default {
  name: "edit-check",
  components: {
    Header
  },
  mounted() {
    const self = this;
    this.isLoading = true;
    firebase
      .firestore()
      .collection(FirestoreCollection.USERS)
      .get()
      .then(snapshot => {
        snapshot.forEach(doc => {
          let user = new User(doc);
          if (user.hasCompletedOnboarding) {
            self.checkers.push(user);
          }
        });
        if (this.$route.params.checkID) {
          this.checkID = this.$route.params.checkID;
        } else {
          self.isLoading = false;
          return;
        }

        firebase
          .firestore()
          .collection(FirestoreCollection.CHECKS)
          .doc(self.checkID)
          .get()
          .then(doc => {
            self.check = new Check(doc);
            if (doc.exists) {
              self.form.customerIdentity.value = self.check.customerIdentity;
              self.form.title.value = self.check.title;
              self.form.status.value = self.check.status;
              self.selectedChecker = self.checkers.find(
                e => e.uid === self.check.participatingUserUID
              );
              if (self.selectedChecker === undefined) {
                self.selectedChecker = {};
              } else {
                self.form.participatingUserUID.value =
                  self.check.participatingUserUID;
                self.form.participatingUsername.value =
                  self.check.participatingUsername;
              }
              self.form.goodType.value = self.check.goodType;
              self.form.address.value = self.check.address;
              self.form.zipCode.value = self.check.zipCode;
              self.form.city.value = self.check.city;
              self.form.country.value = self.check.country;
            } else {
              self.displayMessage(
                "Impossible d'éditer ce Check, il est inexistant.",
                NotificationType.ERROR
              );
              return;
            }
            self.isLoading = false;
          })
          .catch(function() {
            self.displayMessage(
              "Erreur lors de la récupération du Check.",
              NotificationType.ERROR
            );
            self.isLoading = false;
          });
      })
      .catch(function() {
        self.isLoading = false;
        self.displayMessage(
          "Erreur lors de la récupérations des checkers.",
          NotificationType.ERROR
        );
      });
  },

  data() {
    return {
      checkers: [],
      check: {},
      selectedChecker: {},
      dataStatuses: [
        { type: CheckStatus.OPEN, title: "Non affecté" },
        {
          type: CheckStatus.PENDING,
          title: "Affecté (en attente de réalisation)"
        },
        { type: CheckStatus.WAITING_REVIEW, title: "Attente correction" },
        { type: CheckStatus.INVOICED, title: "Terminé (facturé)" },
        { type: CheckStatus.DONE, title: "Terminé" },
        {
          type: CheckStatus.UNDEFINED,
          title: "Non défini (non visible par les checkers)"
        }
      ],
      dataGoodTypes: [
        { type: GoodType.VILLA, title: "Villa" },
        { type: GoodType.STUDIO, title: "Studio" },
        { type: GoodType.APARTMENT, title: "Appartement" },
        { type: GoodType.LOFT, title: "Loft" },
        { type: GoodType.HOME, title: "Maison" }
      ],
      form: {
        customerIdentity: { value: "", hasError: false },
        title: { value: "", hasError: false },
        status: { value: CheckStatus.OPEN, hasError: false },
        participatingUserUID: { value: "", hasError: false },
        participatingUsername: { value: "", hasError: false },
        goodType: { value: GoodType.VILLA, hasError: false },
        address: { value: "", hasError: false },
        zipCode: { value: "", hasError: false },
        city: { value: "", hasError: false },
        country: { value: "France", hasError: false }
      },
      isLoading: false,
      isUploadingReport: false,
      isDownloadingReport: false,
      checkID: ""
    };
  },
  methods: {
    didChangeChecker: function() {
      if (this.selectedChecker != {}) {
        this.form.status.value = CheckStatus.PENDING;
      }
    },

    didChangeStatus: function() {
      if (
        this.form.status.value == CheckStatus.OPEN ||
        this.form.status.value == CheckStatus.UNDEFINED
      ) {
        this.selectedChecker = {};
      }
    },

    deleteCheck: function() {
      if (confirm("Êtes vous sûr(e) de vouloir supprimer ce Check ?")) {
        const self = this;
        firebase
          .firestore()
          .collection(FirestoreCollection.CHECKS)
          .doc(this.check.uid)
          .delete()
          .then(() => {
            router.push({ path: "/checks" });
            self.displayMessage(
              "Check supprimé avec succès.",
              NotificationType.SUCCESS
            );
          })
          .catch(function(error) {
            console.log("Error removing documents: ", error);
          });
      }
    },

    isZipCode: function() {
      var regex = RegExp("[0-9]{5}$");
      this.form.zipCode.value = this.form.zipCode.value.trim();
      this.form.zipCode.hasError = !regex.test(this.form.zipCode.value);
      if (this.form.zipCode.hasError) {
        this.form.zipCode.errorMessage = "Doit comporter 5 chiffres.";
      } else {
        this.form.zipCode.errorMessage = "";
      }
    },

    checkTitle: function() {
      var regex = RegExp("[a-zA-Z0-9._%+-]{2,}");
      this.form.title.value = this.form.title.value.trim();
      this.form.title.hasError = !regex.test(this.form.title.value);
      if (this.form.title.hasError) {
        this.form.title.errorMessage = "Doit contenir au moins deux caractères";
      } else {
        this.form.title.errorMessage = "";
      }
    },

    checkIdentity: function() {
      var regex = RegExp("[a-zA-Z0-9._%+-]{2,}");
      this.form.customerIdentity.value = this.form.customerIdentity.value.trim();
      this.form.customerIdentity.hasError = !regex.test(
        this.form.customerIdentity.value
      );
      if (this.form.customerIdentity.hasError) {
        this.form.customerIdentity.errorMessage =
          "Doit contenir au moins deux caractères";
      } else {
        this.form.customerIdentity.errorMessage = "";
      }
    },

    checkAddress: function() {
      var regex = RegExp("[a-zA-Z0-9._%+-]{2,}");
      this.form.address.value = this.form.address.value.trim();
      this.form.address.hasError = !regex.test(this.form.address.value);
      if (this.form.address.hasError) {
        this.form.address.errorMessage =
          "Doit contenir au moins deux caractères";
      } else {
        this.form.address.errorMessage = "";
      }
    },

    checkCity: function() {
      var regex = RegExp("[a-zA-Z0-9._%+-]{2,}");
      this.form.city.value = this.form.city.value.trim();
      this.form.city.hasError = !regex.test(this.form.city.value);
      if (this.form.city.hasError) {
        this.form.city.errorMessage = "Doit contenir au moins deux caractères";
      } else {
        this.form.city.errorMessage = "";
      }
    },

    checkCountry: function() {
      var regex = RegExp("[a-zA-Z0-9._%+-]{2,}");
      this.form.country.value = this.form.country.value.trim();
      this.form.country.hasError = !regex.test(this.form.country.value);
      if (this.form.country.hasError) {
        this.form.country.errorMessage =
          "Doit contenir au moins deux caractères";
      } else {
        this.form.country.errorMessage = "";
      }
    },

    editCheck: function() {
      const self = this;
      var data = {};
      if (confirm("Vous confirmez vouloir éditer ce Check ?")) {
        this.isLoading = true;
        data.customerIdentity = this.form.customerIdentity.value;
        data.title = this.form.title.value;
        data.status = this.form.status.value;
        if (this.selectedChecker.uid && this.selectedChecker.uid.length > 0) {
          data.participatingUserUID = this.selectedChecker.uid;
          data.participatingUsername =
            this.selectedChecker.firstName +
            " " +
            this.selectedChecker.lastName;
        } else {
          data.participatingUserUID = "";
          data.participatingUsername = "";
        }
        data.goodType = this.form.goodType.value;
        data.address = this.form.address.value;
        data.zipCode = this.form.zipCode.value;
        data.city = this.form.city.value;
        data.country = this.form.country.value;
        if (self.checkID === "") {
          data.uid = makeCheckID(20);
          data.createdAt = new Date();
        } else {
          data.uid = self.checkID;
        }
        firebase
          .firestore()
          .collection(FirestoreCollection.CHECKS)
          .doc(data.uid)
          .set(data, { merge: true })
          .then(() => {
            self.isLoading = false;
            router.push({ path: "/checks" });
            let message =
              self.checkID == ""
                ? "Check édité avec succès."
                : "Check créé avec succès.";
            self.displayMessage(message, NotificationType.SUCCESS);
          })
          .catch(function() {
            self.isLoading = false;
          });
      }
    },

    generateReport: function() {
      const self = this;
      var request = new XMLHttpRequest();

      var url =
        process.env.VUE_APP_ROOT_FIREBASE_PATH +
        ".cloudfunctions.net/generateReport?checkID=" +
        this.checkID;

      request.open("GET", url, true);
      self.isUploadingReport = true;
      request.onload = function() {
        console.log("B");
        if (request.status >= 200 && request.status < 400) {
          self.check.hasReport = true;
          firebase
            .firestore()
            .collection(FirestoreCollection.CHECKS)
            .doc(self.checkID)
            .set(self.check.data, { merge: true })
            .then(() => {
              self.isUploadingReport = false;
            })
            .catch(function() {
              self.isUploadingReport = false;
            });
        } else {
          self.isUploadingReport = false;
        }
      };
      request.onerror = function() {
        self.isUploadingReport = false;
      };
      var data = JSON.stringify({ checkID: this.checkID });
      request.send(data);
    },

    consultReport: function() {
      const self = this;
      const storage = firebase.storage().ref();
      var path = self.check.reportStoragePath();
      self.isDownloadingReport = true;
      storage
        .child(path)
        .getDownloadURL()
        .then(function(url) {
          self.isDownloadingReport = false;
          window.open(url, "_blank", "fullscreen=yes");
        })
        .catch(function(error) {
          self.isDownloadingReport = false;
          self.displayMessage(
            "Des modifications ont été apporté, vous devez d'abord mettre à jour le rapport PDF.",
            "info"
          );
          console.log(error);
        });
    },

    displayMessage: function(message, type) {
      UIkit.notification("<span uk-icon='check: warning'></span> " + message, {
        pos: "top-right",
        status: type
      });
    }
  }
};

String.prototype.capitalize = function() {
  return this.charAt(0).toUpperCase() + this.slice(1);
};

function makeCheckID(length) {
  var result = "";
  var characters = "ABCDEFGHIJKLMNOPQRSTUVWXYZ0123456789";
  var charactersLength = characters.length;
  for (var i = 0; i < length; i++) {
    result += characters.charAt(Math.floor(Math.random() * charactersLength));
  }
  return result;
}
</script>

<style scoped>
.uk-background-secondary {
  background-color: #309fb520;
}
</style>